var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElasticsearchDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.5 98H121.25C121.5 99.25 122 100.5 122.25 101.5C124 107.5 125 113.75 125.5 120.25C125.75 122.75 125.75 125.5 125.75 128C125.75 130.5 125.75 133.25 125.5 135.75C125 142.25 124 148.5 122.25 154.5C122 155.75 121.5 157 121.25 158H173.5C190 158 203.25 144.5 203.25 128C203.25 111.5 190 98 173.5 98Z",
    fill: "#00A9E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 135.75C125.75 133.25 125.75 130.5 125.75 128C125.75 125.5 125.75 122.75 125.5 120.25C125 113.75 124 107.5 122.25 101.5C122 100.25 121.5 99 121.25 98H40.5C37.5 107.5 36 117.5 36 128C36 138.5 37.5 148.5 40.5 158H121.25C121.5 156.75 122 155.5 122.25 154.5C124 148.5 125 142.25 125.5 135.75Z",
    fill: "#353535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 168H117.5C115.5 172.5 113.25 176.75 110.75 180.75C107 187 102.5 192.5 97.5001 197.75C95.7501 199.5 94.0001 201 92.2501 202.75C88.7501 206 84.7501 208.75 80.7501 211.5C96.5001 222 115.5 228 135.75 228C170.5 228 201 210.25 219 183.5C209.75 174 196.75 168 182.5 168Z",
    fill: "#00BFB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.75 180.75C113.25 176.75 115.5 172.5 117.5 168H44.25C52 185.75 64.75 201 81 211.5C85 208.75 88.75 206 92.5 202.75C94.25 201.25 96 199.5 97.75 197.75C102.5 192.75 107 187 110.75 180.75Z",
    fill: "#019B8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 58.25C95.75 56.5 94 55 92.25 53.25C88.75 50 84.75 47.25 80.75 44.5C64.75 55 52 70.25 44 88H117.5C115.5 83.5 113 79 110.5 75C107 68.75 102.5 63.25 97.5 58.25Z",
    fill: "#F9B110"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.75 28C115.5 28 96.5001 34 80.7501 44.5C84.7501 47.25 88.5001 50 92.2501 53.25C94.0001 54.75 95.7501 56.5 97.5001 58.25C102.5 63.5 107 69 110.75 75.25C113.25 79.25 115.5 83.5 117.5 88H182.5C196.75 88 209.75 82 219 72.5C201 45.75 170.5 28 135.75 28Z",
    fill: "#FED10A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticsearchDark);
export default __webpack_public_path__ + "static/media/Elasticsearch-Dark.63699a6a1b5173b08e1877f3b78bd61d.svg";
export { ForwardRef as ReactComponent };